import { Loader } from "@mantine/core";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, Polyline, withGoogleMap, withScriptjs } from "react-google-maps";
import { compose, withProps } from "recompose";

const MapRouting = compose(
  withProps((props) => ({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDV8uT7yErfIloYQBp_PXlEyJnTBWJ3Hpk&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <Loader />,
    containerElement: <div style={{ height: props.height || `400px`, position: 'relative' }} />,
    mapElement: <div style={{ height: `100%` }} />,
  })),
  withScriptjs,
  withGoogleMap,
)((props) => {
  const { path = [], onPoint, selected } = props;

  const [currentPath, setCurrentPath] = useState(null);

  useEffect(() => {
    if(!currentPath && path.length > 0) setCurrentPath(path[0]);
  },[currentPath, path])

  return (
    <>
      <GoogleMap
        defaultCenter={path[0]?.location}
        defaultZoom={13}
      >
        <Polyline
          path={path.filter(nn => nn).map(p => p.location)}
          options={{
            strokeColor: "#FF0000",
            strokeOpacity: 0.4,
            strokeWeight: 4
          }}
        />
        {path.map((p, index) => <Marker
          onClick={() => onPoint && onPoint({item: p, index})}
          position={p.location}
          icon={selected === index ? undefined
            : {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 2,
            strokeColor: '#FF0000',
          }}
        />)}
      </GoogleMap>
    </>
  );
});

export default MapRouting;